import { render } from "./PlayersComponent.vue?vue&type=template&id=18c7d414&scoped=true"
import script from "./PlayersComponent.vue?vue&type=script&lang=js"
export * from "./PlayersComponent.vue?vue&type=script&lang=js"

import "./PlayersComponent.vue?vue&type=style&index=0&id=18c7d414&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c7d414"]])

export default __exports__